import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BillingPage } from '#/pages/billing';

export const Route = createFileRoute('/_protected/billing/')({
  validateSearch: z.object({
    tab: z.enum(['orders', 'subscription', 'payment-plans']).optional().catch(undefined),
  }),
  component: () => <BillingPage />,
});

export const useBillingPageSearch = Route.useSearch;
export const useBillingPageNavigate = Route.useNavigate;
